import classNames from "classnames";

type FormGroupProps = {
    children?: React.ReactNode;

    hasViolation?: boolean;
}

export const FormGroup = ({children, hasViolation}: FormGroupProps) => {
    const classes = classNames("form-group", {
        "has-error": hasViolation,
        "has-feedback": hasViolation
    })


    return <div className={classes}>
        {children}
    </div>
}